import React, { useState } from "react";
import HeroBadge from "./hero/HeroBadge";
import HeroButton from "./hero/HeroButton";
import SmileCard from "./hero/SmileCard";
import DemoVideoModal from "./DemoVideoModal";

const Hero = () => {
  const [isDemoOpen, setIsDemoOpen] = useState(false);

  return (
    <section className="relative mx-auto pt-32 md:pt-40 max-w-full px-3 sm:px-4 lg:px-6 pb-12 flex flex-col items-center justify-center text-center overflow-hidden">
      {/* Background Gradients removed (now in App.js) */}

      {/* Top Badge */}
      <div className="animate-fade-in-up">
        <HeroBadge>AI-Powered Smile Simulation for Dental Practices</HeroBadge>
      </div>

      {/* Heading */}
      <h1 className="text-4xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-gray-900 mb-3 md:mb-2 max-w-4xl leading-[1.1] animate-fade-in-up delay-100">
        The Fastest Way to Get <br className="hidden md:block" />
        Patients to Say <span className="text-[#0066ff]">YES</span>
      </h1>

      {/* Description */}
      <p className="text-sm md:text-lg text-gray-600 mb-4 md:mb-8 max-w-3xl leading-relaxed animate-fade-in-up delay-200">
        SmileReveal™ is <strong>dental smile simulation software</strong> that
        uses AI to show patients their future smile in seconds.{" "}
        <strong>Boost case acceptance rates to 60%+</strong> for implants,
        veneers, and All-on-X — without pressure or discounting.
      </p>

      {/* Buttons */}
      <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-4 md:mb-8 w-full px-2 animate-fade-in-up delay-300">
        <HeroButton href="https://app.smilereveal.io">Get Started</HeroButton>
        <HeroButton onClick={() => setIsDemoOpen(true)} variant="secondary">Watch Demo</HeroButton>
      </div>

      <DemoVideoModal isOpen={isDemoOpen} onClose={() => setIsDemoOpen(false)} />

      {/* Image Showcase Section */}
      <div className="relative w-full max-w-full mx-auto  mt-2 md:mt-4 pb-4 md:pb-8 animate-fade-in-up delay-500">
        {/* ── MOBILE: overlapping stacked cards (hidden on md+) ── */}
        <div className="block md:hidden relative min-h-[320px] mt-10 w-full max-w-[320px] mx-auto">
          <SmileCard
            label="Before"
            imageSrc="/before_hero.webp"
            imageAlt="Patient before AI dental smile simulation"
            className="absolute left-1 top-2 z-10"
            mobile
          />

          <SmileCard
            label="After"
            imageSrc="/after_hero.webp"
            imageAlt="After AI smile simulation preview showing dental implant results"
            isAfter
            className="absolute left-[38%] top-[28%] z-20"
            mobile
          />

          {/* Arrow + caption */}
          <div className="absolute right-10 -top-6 z-40 flex flex-col items-center">
            <p className="mt-1  text-slate-600 font-bold text-xs max-w-[120px] leading-tight text-center animate-bounce-slow">
              AI smile preview generated in seconds by SmileReveal
            </p>

            <img
              src="/svgs/hero_arrow.svg"
              alt="Preview arrow"
              width="70"
              height="40"
              className="w-[70px] h-auto object-contain -rotate-14"
            />
          </div>
        </div>

        {/* ── DESKTOP: original side-by-side layout (hidden below md) ── */}
        <div className="hidden md:flex flex-row items-center justify-center gap-12 lg:gap-48 relative">
          <SmileCard
            label="Before"
            imageSrc="/before_hero.webp"
            imageAlt="Patient before AI dental smile simulation"
          />

          {/* Transition Element */}
          <div className="flex flex-col items-center justify-center z-20 mt-2 lg:mt-4 scale-90 lg:scale-100">
            <img
              src="/svgs/hero_arrow.svg"
              alt="Preview arrow"
              width="150"
              height="80"
              className="w-[120px] lg:w-[150px] h-auto object-contain -rotate-[30deg]"
            />

            <p className="text-slate-600 font-bold text-lg lg:text-xl max-w-[160px] leading-tight text-center animate-bounce-slow">
              AI smile preview generated in seconds by SmileReveal
            </p>
          </div>

          <SmileCard
            label="After"
            imageSrc="/after_hero.webp"
            imageAlt="After AI smile simulation preview showing dental implant results"
            isAfter
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
